module.exports = __webpack_public_path__ + "img/sld_grid_ta1_ba1_dark.81a37ac3.svg";